import type { StatementView } from '@/api/generated';
import { CSV_BOM, csvField, guardFormula, minorToDecimal } from '@/utils/csv';

const HEADER =
  'statement_id,period_start,period_end,charge_status,kind,description,reference,quantity,amount,currency';

/**
 * One subscriber statement's lines as CSV (the per-tenant Statements tab, TMMRSL-0029). Text cells
 * carry 0028's formula-injection guard (H §9.5); amounts are plain decimals in the statement's
 * currency; empty when the currency is blank. A zero amount is `0.00`.
 */
export function statementCsv(stmt: StatementView): string {
  const currency = stmt.currency;
  const amount = (minor: number) => (currency ? minorToDecimal(minor, currency) : '');
  const rows = stmt.lines.map((line) =>
    [
      String(stmt.id),
      guardFormula(stmt.periodStart),
      guardFormula(stmt.periodEnd),
      guardFormula(stmt.chargeStatus),
      guardFormula(line.kind),
      guardFormula(line.description),
      guardFormula(line.reference ?? ''),
      line.quantity === undefined ? '' : String(line.quantity),
      amount(line.amountMinor),
      guardFormula(currency),
    ]
      .map(csvField)
      .join(','),
  );
  return `${CSV_BOM}${HEADER}\n${rows.join('\n')}${rows.length > 0 ? '\n' : ''}`;
}

export function statementFilename(slug: string, stmt: StatementView): string {
  return `tmm-reseller-statement-${slug}-${stmt.id}.csv`;
}
